<div
    *ngIf="isVisible"
    class="modal-backdrop"
    @showHideTrigger
    (click)="closeModal()"
>
    <div class="modal" (click)="$event.stopPropagation()">
        <div class="modal-body">
            @if(!isHideHeader)
            {
                <div class="modal-header">
                    <ng-content select="[modal-title]"></ng-content>

                    <button class="modal-close" (click)="closeModal()">
                        <app-icon-close-small></app-icon-close-small>
                    </button>
                </div>
            }
            <ng-content select="[modal-body]"></ng-content>
        </div>
    </div>
</div>
